module.exports = __webpack_public_path__ + "static/media/message.b3d4bfdf.gif";